import { useLanguage } from '../i18n/useLanguage';
import { socialLinks } from '../lib/socialLinks';

// Floating left-edge rail (Figma 120:2268). Three wooden-disc social
// buttons stacked vertically. Disc bg + per-platform SVG glyph come
// from the Figma export so the rail matches the cooking-themed art
// style of the rest of the page.
export default function FloatingSocialRail() {
  const { lang } = useLanguage();
  const links = socialLinks(lang);

  return (
    <aside
      aria-label="Social links"
      className="pointer-events-none fixed left-2 top-1/2 z-30 hidden -translate-y-1/2 md:left-3 md:block"
    >
      {/* Figma uses 50px gaps between discs; we keep a tighter gap on
          smaller md viewports and let it grow on lg so the rail stays
          visually balanced against the page chrome. */}
      <ul className="pointer-events-auto flex flex-col gap-4 lg:gap-6">
        {links.map((link) => (
          <li key={link.platform}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
              className="relative flex aspect-square w-12 select-none transition hover:scale-110 active:scale-95 lg:w-14"
            >
              {/* <img
                src="/images/social-disc.png"
                alt=""
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 h-full w-full select-none object-contain"
                draggable={false}
              /> */}
              {/* Glyph centred on the disc face. The disc is slightly
                  taller than wide (70×74.375) because the asset bakes
                  in a thin shadow at the bottom — the visible "face"
                  sits a hair above the geometric centre, so we nudge
                  the glyph up ~3% to land on it. */}
              <img
                src={link.glyph}
                alt=""
                aria-hidden="true"
                className="aspect-square w-full h-full pointer-events-none object-contain select-none"
                draggable={false}
              />
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
}
